import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@otcmarketsgroup/otcm-ui-lib';
import { storage } from '../../constants';
import { formatDate } from '../../utlis/helper';
import config from '../../config';
import styles from './MarketReportTable.module.scss';

const { STATIC_URL } = config;
const sessionStorageToken = window.sessionStorage.getItem(storage.TOKEN);

const MarketReportTable = ({ data, symbol, onShareClick }) => {
    const [dataSet, setDataSet] = useState(null);
    const [mobileView, setMobileView] = useState(false);

    useEffect(() => {
        setDataSet([...data]);
    }, [data]);

    useEffect(() => {
        const handleResize = () => {
            // Check browser width and toggle columns accordingly
            if (window.innerWidth < 768) {
                setMobileView(true);
            } else {
                setMobileView(false);
            }
        };

        // Initial setup
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup  
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const columns = [
        {
            header: 'Week Ending',
            id: 'date',
            width: mobileView ? '32%' : '27%',
            renderCell: item => <div>{formatDate(item?.date)}</div>
        },
        {
            header: 'Symbol',
            id: 'symbol',
            width: mobileView ? '22%' : '20%'
        },
        {
            header: 'Report',
            id: 'reportId',
            width: mobileView ? '21%' : '18%',
            renderCell: item => <a className={styles.link} href={`${STATIC_URL}/market-report/report/pdf/${symbol}?reportId=${item?.reportId}&date=${item?.date}&token=${sessionStorageToken}`} target='_blank' rel='noopener noreferrer'>
                <div>View</div>
            </a>
        },
        {
            width: mobileView ? '25%' : '40%',
            renderCell: item => (
                <div className={styles.link} onClick={() => onShareClick(item)}>
                    <div>Share Market Report</div>
                </div>
            )
        }
    ];

    return <div className={styles.container}>
        <Table
            columns={columns}
            data={data}
            emptyDataText='No Market Reports Found'
            errorText={undefined}
            emptyValue='Not available'
        />
    </div>;
};

MarketReportTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string,
            symbol: PropTypes.string,
            reportId: PropTypes.number,
            data: PropTypes.object,
        })
    ),
    symbol: PropTypes.string.isRequired,
    onShareClick: PropTypes.func.isRequired
};

export default MarketReportTable;
